// removed by extract-text-webpack-plugin
module.exports = {"accountSwitcher":"accountSwitcher___28J0W"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AccountSwitcher/styles.less
// module id = EJPV
// module chunks = 18